// extracted by mini-css-extract-plugin
module.exports = {"root":"CounterpartyDetailView_root_2OLit","inner":"CounterpartyDetailView_inner_3Kv1F"};